import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    appBar: {
        height: 90,
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    toolbar: {
        height: 90,
        alignItems: 'center',
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    link: {
        margin: theme.spacing(1, 1.5),
    },
}));
